export const interceptorResponse = async (response) => {
  return response.data;
};
